import React from "react";

function OrderDone_svg() {
  return (
    <svg className="MuiSvgIcon-root" viewBox="0 0 118 118" fill="none">
      <path
        d="M58.999 0C43.3515 0 28.3445 6.21603 17.2807 17.2807C6.21603 28.3454 0 43.3521 0 58.999C0 74.646 6.21603 89.6535 17.2807 100.717C28.3454 111.782 43.3521 117.998 58.999 117.998C74.646 117.998 89.6535 111.782 100.717 100.717C111.782 89.6527 117.998 74.646 117.998 58.999C117.98 43.3568 111.759 28.3614 100.698 17.3004C89.6375 6.23907 74.6407 0.0174189 58.999 0ZM58.999 108.166C45.959 108.166 33.4533 102.986 24.2342 93.765C15.0134 84.5453 9.83327 72.0396 9.83327 59.0002C9.83327 45.9607 15.0134 33.4545 24.2342 24.2353C33.4539 15.0146 45.9596 9.83439 58.999 9.83439C72.0385 9.83439 84.5447 15.0146 93.7638 24.2353C102.985 33.455 108.165 45.9607 108.165 59.0002C108.149 72.0357 102.965 84.5326 93.7475 93.7481C84.531 102.966 72.0343 108.15 58.9996 108.165L58.999 108.166Z"
        fill="#017EFA"
      />
      <path
        d="M85.0212 35.8548L51.6218 69.2542L37.8903 55.5227C36.648 54.2826 34.8384 53.7986 33.1428 54.2541C31.4472 54.7084 30.1226 56.033 29.6683 57.7286C29.2129 59.4242 29.6968 61.234 30.937 62.4761L48.1452 79.6843C49.067 80.6061 50.3182 81.1242 51.6219 81.1242C52.9257 81.1242 54.1769 80.6061 55.0987 79.6843L91.9735 42.8095C93.2136 41.5672 93.6976 39.7576 93.2421 38.062C92.7878 36.3665 91.4631 35.0418 89.7676 34.5875C88.072 34.1321 86.2622 34.6161 85.0201 35.8562L85.0212 35.8548Z"
        fill="#017EFA"
      />
    </svg>
  );
}

export default OrderDone_svg;
